import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

type SubmitHandler = (searchTerm: string, siteUrl: string) => void

export type SearchBoxProps = {
    handleSubmit: SubmitHandler
    typing: (chars: string, siteUrl: string) => void
    autocompleteTyping: ({chars, territory, cookie}: {chars: string; territory: string; cookie: string}) => void
    backgroundImage: string
    placeholder: string
    typedCharacters: any
    openDrawer: () => void
    labelId: string
    text: any
    realm: string
    autoFocus: boolean
    setAutoCompleteIsLoading: () => void
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    siteUrl: string
    autocompleteTerritory: string
    cookie?: string
    xxlBreakpointEnabled: boolean
    isTpSuperLite: boolean
    cleanSiteUrl: string
    clearIconUrl: string
}

export const SearchBox = memo(
    ({
        placeholder,
        typing,
        autocompleteTyping,
        backgroundImage,
        handleSubmit,
        openDrawer,
        typedCharacters,
        labelId,
        text,
        autoFocus,
        setAutoCompleteIsLoading,
        templating,
        siteUrl,
        autocompleteTerritory,
        cookie,
        xxlBreakpointEnabled,
        cleanSiteUrl,
        isTpSuperLite,
        clearIconUrl,
    }: SearchBoxProps) => {
        const SearchBoxComponent = useTemplatedComponent(
            {mainTemplate: templating.mainTemplate, fallbackTemplate: templating.fallbackTemplate},
            MANIFEST,
        )
        return (
            <Suspense>
                <SearchBoxComponent
                    placeholder={placeholder}
                    typing={typing}
                    autocompleteTyping={autocompleteTyping}
                    backgroundImage={backgroundImage}
                    handleSubmit={handleSubmit}
                    openDrawer={openDrawer}
                    typedCharacters={typedCharacters}
                    labelId={labelId}
                    text={text}
                    autoFocus={autoFocus}
                    setAutoCompleteIsLoading={setAutoCompleteIsLoading}
                    siteUrl={isTpSuperLite ? cleanSiteUrl : siteUrl}
                    autocompleteTerritory={autocompleteTerritory}
                    cookie={cookie}
                    xxlBreakpointEnabled={xxlBreakpointEnabled}
                    clearIconUrl={clearIconUrl}
                />
            </Suspense>
        )
    },
)
SearchBox.displayName = "SearchBox"

export default connect(SearchBox)
